module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1529-1d090b6112005aa9c1477c991b452a77.png";